// extracted by mini-css-extract-plugin
export default {"l":"bff163333a"};